<script setup lang="ts">
import type { SelectIndicatorProps } from "./";
import { useSharedState } from "composables/useSharedState";
import { useSelect } from "./useSelect";

defineOptions({ name: "SelectIndicator" });

const props = withDefaults(defineProps<SelectIndicatorProps>(), {
  indicatorIcon: "chevron-down",
});

useSharedState(props);

const select = useSelect();
</script>

<template>
  <span part="indicator" class="e-select-indicator">
    <slot>
      <e-icon exportparts="base:icon-base" :name="select.isOpen.value ? 'chevron-up' : props.indicatorIcon" size="sm" />
    </slot>
  </span>
</template>

<style>
:host {
  display: contents;
}
</style>
